import { useEffect, useState } from "react";
import { FieldError } from "react-hook-form";
import useAccessToken from "../auth/useAccessToken";
import FormDropdown from "./FormDropdown";
import { FormSearchDropdownOption } from "./FormSearchDropdown/FormSearchDropdown";
import { fetchLanguages } from "../api/languages";

export type LanguageDropdownProps = {
    value: string
    onChange: (value: string, option: FormSearchDropdownOption | null) => void
    disabled?: boolean
    required?: boolean
    error?: FieldError
    tooltip?: string
    label?: string
}

const LanguageDropdown = ({
    value,
    onChange,
    disabled,
    required,
    error,
    tooltip,
    label
}: LanguageDropdownProps) => {
    const accessToken = useAccessToken();
    const [allLanguageOptions, setAllLanguageOptions] = useState<FormSearchDropdownOption[]>([]);

    const fetchLanguageOptions = async () => {
        const languagesResponse = await fetchLanguages(undefined, accessToken);
        return languagesResponse
            .map(experience => ({
                value: experience.id,
                label: experience.name,
            }));
    };

    useEffect(() => {
        if (!accessToken) return;

        const loadAllLanuages = async () => {
            const fetchedLanguages = await fetchLanguageOptions();
            setAllLanguageOptions(fetchedLanguages);
        };

        loadAllLanuages();
    }, [accessToken]);

    if (allLanguageOptions.length < 1) return <div className="my-4">Loading...</div>;

    return (
        <FormDropdown
            required={required}
            label={label}
            tooltip={tooltip}
            options={allLanguageOptions}
            error={error}
            value={value}
            onChange={onChange}
            disabled={disabled}
        />
    );
};

export default LanguageDropdown;